module.exports = __webpack_public_path__ + "static/thumb-drones-api-51175e5925c434f83a0471b7d7efdd2a.png";